import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-brand">
          <h3>SOLOLA</h3>
          <p>Connectez-vous avec n'importe qui, n'importe où. La solution de visioconférence moderne et sécurisée.</p>
          <div className="footer-social">
            <a href="https://www.facebook.com/profile.php?id=61592624611383" title="Facebook">f</a>
            <a href="https://x.com/CHYBIATECH" title="Twitter">𝕏</a>
            <a href="https://www.linkedin.com/in/mardoché-précieux-nkondani?utm_source=share_via&utm_content=profile&utm_medium=member_android" title="LinkedIn">in</a>
            <a href="https://www.youtube.com/" title="YouTube">▶</a>
          </div>
        </div>

        <div className="footer-links">
          <div>
            <h4>Support</h4>
            <a href="#">Centre d'aide</a>
            <a href="#">Contact</a>
            <a href="#">FAQ</a>
            <a href="#">Guide d'utilisation</a>
          </div>

          <div>
            <h4>Légal</h4>
            <a href="#">Confidentialité</a>
            <a href="#">Conditions d'utilisation</a>
            <a href="#">Politique de cookies</a>
          </div>

          <div>
            <h4>Entreprise</h4>
            <Link to="/about">À propos</Link>
            <a href="#">Carrières</a>
            <a href="#">Presse</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {year} SOLOLA. Tous droits réservés.</p>
        <span>Version 1.0.0</span>
      </div>
    </footer>
  );
};

export default Footer;
